<template>
    <div>
        <v-layout row wrap v-if="!this.loading">
            <v-flex xs12 lg3 offset-xs1 offset-lg1>
                <v-card class="pa-2" style="text-align:center">
                    <v-card-text>
                        <p class="subheading" style="font-weight:500">Demandas Avaliadas</p>
                        <p class="subheading" style="font-weight:600"><strong>{{this.summary.totalEvaluated}}</strong></p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 lg3 offset-xs1 offset-lg1>
                <v-card class="pa-2" style="text-align:center">
                    <v-card-text>
                        <p class="subheading" style="font-weight:500">Demandas em Avaliação</p>
                        <p class="subheading" style="font-weight:600"><strong>{{this.summary.totalNotEvaluated}}</strong></p>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 lg2 offset-xs1 offset-lg1>
                <v-card class="pa-2" style="text-align:center">
                    <v-card-text>
                        <p class="subheading" style="font-weight:500">Score Médio</p>
                        <p class="subheading" style="font-weight:600">
                            <strong style="color:red" v-if="this.summary.totalAverageValue < 3">{{this.summary.totalAverage}}</strong>
                            <strong style="color:orange" v-if="this.summary.totalAverageValue == 3">{{this.summary.totalAverage}}</strong>
                            <strong style="color:green" v-if="this.summary.totalAverageValue > 3">{{this.summary.totalAverage}}</strong>
                        </p>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <br />
        <app-sercheable-data-table v-if="!this.loading" :headers="headers" :search="search" :refresh="loadEvaluateOffices" :placeholder="placeholder" :pagination="pagination">
            <template slot="items" slot-scope="{item}">
                <router-link :to="{ name: 'officeEvaluatedDemands', params: { officeId: item.id }}" tag="tr">
                    <td>{{ item.id }}</td>
                    <td>{{ item.acronym }}</td>
                    <td>{{ item.name }}</td>
                    <td><strong>{{ item.average }}</strong></td>
                    <v-tooltip bottom tag="td">
                        <span slot="activator">{{ item.notEvaluatedDemands }}</span>
                        <span>As demandas que estão sendo consideradas no cálculo são as que estão na situação  'Aprovação de Entrega'</span>
                    </v-tooltip>
                    <td>{{ item.evaluatedDemands }}</td>
                    <td>{{ item.dtStartEvaluation }}</td>
                </router-link>
            </template>
        </app-sercheable-data-table>
        <dialog-loader v-show="this.loading" />
    </div>

</template>

<script>
import utilities from '@/helpers/utilities';
import SercheableDataTable from '../shared/SercheableDataTable';
import DialogLoader from '../shared/DialogLoader';

export default {
    data() {
        return {
            pagination: {
                descending: false,
                sortBy: 'name',
            },
            headers: [
                {
                    text: this.$t('label.code'),
                    value: 'id',
                    align: 'left',
                },
                {
                    text: this.$t('label.office'),
                    value: 'acronym',
                    align: 'left',
                },
                {
                    text: this.$t('label.name'),
                    value: 'name',
                    align: 'left',
                },
                {
                    text: this.$t('label.averageEvaluationDemands'),
                    value: 'average',
                    align: 'left',
                },
                {
                    text: this.$t('label.notEvaluatedDemands'),
                    value: 'notEvaluatedDemands',
                    align: 'left',
                },
                {
                    text: this.$t('label.evaluatedDemands'),
                    value: 'evaluatedDemands',
                    align: 'left',
                },
                {
                    text: this.$t('label.dateStartEvaluationDemand'),
                    value: 'dtStartEvaluation',
                    align: 'left',
                },
            ],
            loading: true,
            summary: {},
            placeholder: "Busque por Código, Nome ou Sigla da Secretaria"
        };
    },
    methods: {
        search(filters) {
            const offices = this.$store.getters.scoreOffices.avaliacaoSecretarias;

            return utilities.filterMultiple(offices, filters, (office, regex) => (
                regex.test(office.acronym) ||
                regex.test(office.name) ||
                regex.test(office.id)
            ));
        },
        async loadEvaluateOffices() {
            this.loading = true;
            await this.$store.dispatch('getEvaluateOffices');
            this.summary = this.$store.getters.scoreOffices;
            this.loading = false;
        },
    },
    beforeMount() {
        this.loadEvaluateOffices();
    },
    components: {
        appSercheableDataTable: SercheableDataTable,
        DialogLoader
    },
};
</script>




// WEBPACK FOOTER //
// src/components/officesScore/Index.vue